export const getApexDomain = (hostname: string) => {
	return hostname.split('.').splice(-2).join('.');
};
